<template>
  <div class="px-3 py-3 mb-5 col-24 col-md-11">
    <PasswordConfirmationActivationModal
      @update="getMyProfile(getUserType)"
      :two-factory-authentication="twoFactoryAuthentication"
      :actionType="actionType"
    />
    <div class="col d-column">
      <h1 class="title pt-2 mb-0" v-text="$ml.get('users')">Usuários</h1>
      <h1 class="title">
        <span v-text="$ml.get('accountUserSubTitle')" class="pb-2"></span>
      </h1>

      <div v-if="permission" class="card mb-3">
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('newUsers')">
            Novos Usuários
          </h6>
        </div>

        <div class="card-body">
          <form v-on:submit.prevent="">
            <div class="row mb-3">
              <div class="col mr-2">
                <label class="text-muted" v-text="$ml.get('user')"
                  >Usuário</label
                >
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$ml.get('informTheUser')"
                  v-model="name"
                  maxlength="50"
                />
                <transition name="fade">
                  <label
                    v-if="userError && !$v.name.required"
                    class="lblError"
                    v-text="$ml.get('enterUserName')"
                    >Informe o nome do usuário</label
                  >
                  <label
                    v-if="userError && !$v.name.minLength"
                    class="lblError"
                    v-text="
                      $ml
                        .with('f', 6)
                        .with('l', 50)
                        .get('usernameMustBeFromCharacters')
                    "
                    >O nome deve ter de 6 a 50 caracteres</label
                  >
                  <label
                    v-if="userError && !$v.name.regexOTN"
                    class="lblError"
                    v-text="$ml.get('nameIsNotValid')"
                    >O nome não é válido</label
                  >
                </transition>
              </div>

              <div class="col">
                <label class="text-muted">E-mail</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$ml.get('enterYourEmail')"
                  v-model="email"
                />
                <transition name="fade">
                  <label
                    v-if="userError && !$v.email.required"
                    class="lblError"
                    v-text="$ml.get('enterTheEmail')"
                    >Informe o e-mail</label
                  >
                  <label
                    v-if="userError && !$v.email.email"
                    class="lblError"
                    v-text="$ml.get('emailDoesNotAppearToBeValid')"
                    >O e-mail não parece ser válido</label
                  >
                </transition>
              </div>
            </div>

            <div class="row">
              <div class="col mr-2 mb-4">
                <label class="text-muted" v-text="$ml.get('permission')"
                  >Permissão</label
                >
                <multiselect
                  v-model="optionSelected"
                  :options="listOptions"
                  :searchable="false"
                  label="name"
                  :custom-label="nameLang"
                  :close-on-select="true"
                  :show-labels="false"
                  :allow-empty="false"
                  :preselect-first="true"
                  :multiple="false"
                >
                </multiselect>
                <transition name="fade">
                  <label
                    class="lblError msgn"
                    v-text="$ml.get(optionSelected.description)"
                  ></label>
                </transition>
              </div>

              <div class="col">
                <label class="text-muted" v-text="$ml.get('language')"
                  >Idioma</label
                >
                <multiselect
                  v-model="languageOptionSelected"
                  :options="languageOptions"
                  :searchable="false"
                  label="name"
                  :close-on-select="true"
                  :custom-label="nameLang"
                  :show-labels="false"
                  :allow-empty="false"
                  :preselect-first="true"
                  :multiple="false"
                >
                </multiselect>
              </div>
            </div>
            <selectProgram
              class="mt-2"
              :listProgram="listProgram"
              @getPrograms="getPrograms"
              ref="selectProgramComponent"
            />
            <div class="col-md-5 col-sm-6 mt-4 py-2">
              <div class="form-group">
                <button
                  @click="saveUser()"
                  :disabled="loadingBtn"
                  class="btn"
                  style="min-width: 170px"
                >
                  <Spinner v-show="loadingBtn" />
                  <span v-show="!loadingBtn" v-text="$ml.get('addUser')">
                    Adicionar Usuário</span
                  >
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- <div v-if="getUserRole === 'owner'" class="card mb-3 col-24" id="userRestriction">
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('restriction')">
            Restrição
          </h6>
        </div>
        <div class="card-body p-0 px-3 mt-3 form-group col-24">
          <div class="col-24 d-flex justify-content-between" style="gap: 10px">
            <div class="d-flex" style="gap: 10px">
              <label
                style="font-weight: 500"
                class="m-0"
                v-text="$ml.get('labelFeatureTwoFactorAuthentication')"
                >Somente gestores com Two-factor Authentication podem interagir
                com relatórios de programas.</label
              >
            </div>
            <label class="switch mb-0 mr-2">
              <input
                type="checkbox"
                :checked="twoFactoryAuthentication"
                @click.prevent="featureActivationAction('2fa')"
                v-b-modal.modal-email-authentication
              />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div> -->
      <!-- <div v-if="canRequestEmailCode && getUserRole === 'owner'" class="card mb-3 col-24" id="authenticationByEmail">
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('authentication')">
            Autenticação
          </h6>
        </div>
        <div class="card-body p-0 px-3 mt-3 form-group col-24">
          <div class="col-24 d-flex justify-content-between align-items-center">
            <div class="d-flex" style="gap: 10px">
              <label
                style="font-weight: 500"
                class="m-0"
                v-text="$ml.get('authenticationViaEmail')"
                >Habilitar autenticação via email</label
              >
              <VueCustomTooltip
                :label="$ml.get('emailAuthenticationInformation')"
                :multiline="true" size="is-large"
              >
                <svg width="16" height="16" class="mb-1">
                  <image
                    xlink:href="../../../src/assets/svg/info-fill.svg"
                    width="16"
                    height="16"
                  />
                </svg>
              </VueCustomTooltip>
            </div>
            <label class="switch mb-0 mr-2">
              <input
                type="checkbox"
                :checked="emailAuthentication"
                @click.prevent="featureActivationAction('codeEmailCompany')"
                v-b-modal.modal-email-authentication
              />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div> -->
      <!-- <div v-if="getUserRole === 'owner'" class="card mb-3">
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('setPasswordExpiration')">
            Definir expiração de senha
          </h6>
        </div>
        <div class="card-body p-0 px-3 form-group col-24 m-0 mt-3">
          <div class="col-24 d-flex justify-content-between align-items-center">
            <label
              style="font-weight: 500"
              class="m-0"
              v-text="$ml.get('enablePasswordExpiration')"
              >Habilitar expiração de senha</label
            >
            <label class="switch mb-0 mr-2">
              <input type="checkbox" v-model.number="expirePassword" @click="expirePassword ? updateConfigPassword('disable') : ''"/>
              <span class="slider round"></span>
            </label>
          </div>
          <div
            class="col-24 d-flex align-items-center justify-content-between mt-3 mb-2"
          >
            <div class="d-flex" v-if="expirePassword == true">
              <label class="mr-1 mt-3" v-text="$ml.get('expirePasswordConfig')"
                >As senhas dos usuários serão válidas por
              </label>
              <input
                style="width: 4rem"
                class="form-control mt-1 text-center"
                type="number"
                v-model.trim="numberOfDaysPasswordExpiration"
              />
              <label class="ml-1 mt-3" v-text="$ml.get('daysGeneric') + `.`"
                >dia(s).</label
              >
              <label v-show="errorConfigPassword" class="lblError">{{
                $ml.get('isNan')
              }}</label>
            </div>
            <div
              class="ml-4"
              v-if="
                expirePassword == true ||
                company_settings?.expire_password != expirePassword
              "
            >
              <button
                v-if="expirePassword"
                @click="updateConfigPassword"
                :disabled="
                  loadingPasswordConfig ||
                  (company_settings?.expire_password == expirePassword &&
                    company_settings?.days_to_expire ==
                      numberOfDaysPasswordExpiration)
                "
                class="btn mt-1"
                style="min-width: 100px"
              >
                <Spinner v-show="loadingPasswordConfig" />
                <span v-show="!loadingPasswordConfig" v-text="$ml.get('save')"
                  >Salvar</span
                >
              </button>
            </div>
          </div>
        </div>
      </div> -->
      <div class="card mb-3">
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('registeredUsers')">
            Usuários Registrados
          </h6>
        </div>

        <div class="card-body p-0">
          <table>
            <tbody>
              <tr v-show="loading" class="loading">
                <div class="c-loader m-3"></div>
              </tr>
              <div v-if="!loading">
                <tr
                  v-if="
                    !listCompany_members.length && !pending_invitations.length
                  "
                  class="d-flex align-items-center justify-content-center"
                >
                  <h6 class="my-3" v-text="$ml.get('noUserAvailable')">
                    Nenhum usuário disponível
                  </h6>
                </tr>

                <div
                  v-for="(item, index) in listCompany_members"
                  :key="index + 'members'"
                >
                  <tr v-if="item.status == 'active'">
                    <td class="col-11">
                      <strong v-text="item.email"></strong>
                    </td>

                    <td
                      class="col-9 pl-0 text-muted text-capitalize"
                      v-text="$ml.get(item.role)"
                    ></td>

                    <td class="col-2 pl-0">
                      <label class="switch mb-0">
                        <input
                          type="checkbox"
                          :disabled="
                            (item.role == 'owner' && !staff) ||
                            (['owner', 'administrator'].includes(item.role) &&
                              !owner) ||
                            (!owner && !staff && !administrator)
                          "
                          checked
                          @click.prevent="alterStatusUser(item._id)"
                        />
                        <span class="slider round"></span>
                      </label>
                    </td>
                    <td
                      @click="removeUser(item._id)"
                      v-if="
                        staff ||
                        (item.role != 'owner' && owner) ||
                        (!['owner', 'administrator'].includes(item.role) &&
                          administrator)
                      "
                      class="col-1 pl-0 pointer"
                    >
                      <VueCustomTooltip :label="$ml.get('deleteUser')">
                        <svg width="16" height="16">
                          <image
                            xlink:href="../../../src/assets/icons/trash-alt.svg"
                            width="16"
                            height="16"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </td>
                    <td v-else class="col-1 pl-0">
                      <svg width="16" height="16">
                        <image
                          xlink:href="../../../src/assets/svg/delete-fill-disable.svg"
                          width="16"
                          height="16"
                        />
                      </svg>
                    </td>

                    <td
                      v-if="
                        staff ||
                        (item.role != 'owner' && owner) ||
                        (!['owner', 'administrator'].includes(item.role) &&
                          administrator)
                      "
                      @click="showModalRole(item)"
                      class="col-1 pl-0 pointer"
                    >
                      <VueCustomTooltip :label="$ml.get('changePermission')">
                        <svg width="16" height="16">
                          <image
                            xlink:href="../../../src/assets/icons/edit.png"
                            width="16"
                            height="16"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </td>
                    <td v-else class="col-1 pl-0">
                      <svg width="16" height="16">
                        <image
                          xlink:href="../../../src/assets/icons/edit-fill-disable.png"
                          width="16"
                          height="16"
                        />
                      </svg>
                    </td>
                  </tr>
                </div>

                <tr
                  v-for="(item, index) in pending_invitations"
                  :key="index + 'pending'"
                >
                  <td class="col-11">
                    <strong>{{ item.receiver }}</strong>
                  </td>
                  <td
                    class="col-9 pl-0 text-muted text-capitalize"
                    v-text="$ml.get(item.role)"
                  ></td>
                  <td class="col-2 pl-0 text-center">
                    <VueCustomTooltip :label="$ml.get('awaitingAcceptance')">
                      <svg width="16" height="16" class="clock">
                        <image
                          xlink:href="../../../src/assets/icons/clock-waiting.png"
                          width="16"
                          height="16"
                        />
                      </svg>
                    </VueCustomTooltip>
                  </td>
                  <td
                      @click="removePendingUser(item._id)"
                      v-if="
                        staff ||
                        (item.role != 'owner' && owner) ||
                        (!['owner', 'administrator'].includes(item.role) &&
                          administrator)
                      "
                      class="col-1 pl-0 pointer"
                    >
                      <VueCustomTooltip :label="$ml.get('deleteUser')">
                        <svg width="16" height="16">
                          <image
                            xlink:href="../../../src/assets/icons/trash-alt.svg"
                            width="16"
                            height="16"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </td>
                  <td
                    v-if="
                      staff ||
                      (item.role != 'owner' && owner) ||
                      (!['owner', 'administrator'].includes(item.role) &&
                        administrator)
                    "
                    @click="showModalRole(item, true)"
                    class="col-1 pl-0 pointer"
                  >
                    <VueCustomTooltip :label="$ml.get('changeSettings')">
                      <svg width="16" height="16">
                        <image
                          xlink:href="../../../src/assets/icons/edit.png"
                          width="16"
                          height="16"
                        />
                      </svg>
                    </VueCustomTooltip>
                  </td>
                  <td v-else class="col-1 pl-0">
                    <svg width="16" height="16">
                      <image
                        xlink:href="../../../src/assets/icons/edit-fill-disable.png"
                        width="16"
                        height="16"
                      />
                    </svg>
                  </td>
                </tr>
              </div>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="listCompany_inative.length" class="card mb-3">
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('inactiveUsers')">
            Usuários Inativos
          </h6>
        </div>
        <div class="card-body p-0">
          <table>
            <tbody>
              <div
                v-for="(item, index) in listCompany_members"
                :key="index + 'membersInactive'"
                class="remove"
              >
                <tr v-if="item.status == 'inactive'">
                  <td class="col-11 d-flex align-items-center">
                    <strong v-text="item.email"></strong>
                  </td>
                  <td
                    class="col-9 pl-0 text-muted d-flex align-items-center text-capitalize"
                    v-text="$ml.get(item.role)"
                  ></td>
                  <td class="col-2 pl-0 pb-1">
                    <label class="switch mb-0">
                      <input
                        type="checkbox"
                        :disabled="
                          (item.role == 'owner' && !staff) ||
                          (['owner', 'administrator'].includes(item.role) &&
                            !owner) ||
                          (!owner && !staff && !administrator)
                        "
                        @click.prevent="alterStatusUser(item._id)"
                      />
                      <span class="slider round"></span>
                    </label>
                  </td>
                </tr>
              </div>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Alter Role User-->
    <b-modal
      id="modal-alterRole"
      class="modal-analysis pl-3"
      data-bs-keyboard="false"
      hide-header
      footer-bg-variant="light"
      data-bs-backdrop="static"
      aria-hidden="true"
    >
      <b-container fluid="lg">
        <div class="col modal-body">
          <h4 class="m-0">{{ $ml.get('changePermission') }}</h4>
        </div>
      </b-container>

      <div class="d-flex flex-column">
        <p class="mb-3 px-3">
          Deseja alterar a permissão do usuário
          <b>{{ userAlterRole.email || userAlterRole.receiver }} ?</b>
        </p>
        <div class="row px-3 mb-4">
          <div class="col">
            <multiselect
              v-model="optionRoleSelected"
              :options="listOptions"
              :searchable="false"
              label="name"
              :custom-label="nameLang"
              :close-on-select="true"
              :show-labels="false"
              :allow-empty="false"
              :preselect-first="true"
              :multiple="false"
            />
            <transition name="fade">
              <label
                class="lblError msgn"
                v-text="$ml.get(optionRoleSelected.description)"
              ></label>
            </transition>
          </div>
        </div>
        <div
          class="row d-flex align-items-end justify-content-between px-3 mb-2"
        >
          <div class="col">
            <label class="text-muted m-0 p-0" v-text="$ml.get('programs')"
              >Programas</label
            >
            <selectProgram
              class="mt-1"
              :listProgram="listProgram"
              @getPrograms="getPrograms"
              :programSelectedUser="programSelectedUserComputed"
            />
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex justify-content-end px-3 w-100">
          <div class="float">
            <a
              v-show="loadingBtnRole"
              class="btn btn-primary float-right"
              style="width: 92px"
            >
              <Spinner v-show="true" />
            </a>
            <b-button
              v-show="!loadingBtnRole"
              class="float-right"
              variant="primary"
              size="sm"
              @click="
                alterRoleUser(
                  userAlterRole,
                  optionRoleSelected,
                  userAlterRole?._id,
                  userAlterRole.status
                )
              "
              v-text="$ml.get('save')"
            >
            </b-button>
          </div>
          <b-button
            class="float-right btn-outline-extra ml-2"
            size="sm"
            variant="primary"
            @click="cancel()"
          >
            {{ $ml.get('cancel') }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { email, minLength, required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import PasswordConfirmationActivationModal from "../modais/PasswordConfirmationActivationModal.vue";
import AccountService from "../../services/account.service";
import CompanyService from "../../services/company.service";
import ProgramService from "../../services/program.service";
import selectProgram from "../../components/selectProgram.vue"
import { executeRecaptchaV3, RECAPTCHA_V3_ACTIONS } from "../../helpers/recaptchaV3";

import { utils } from "../../utils";
const regexOTN = utils.regexCheck("OTN");
export default {
  components: {
    PasswordConfirmationActivationModal,
    selectProgram,
  },
  data() {
    return {
      actionType: '',
      expirePassword: false,
      emailAuthentication: false,
      canRequestEmailCode: false,
      numberOfDaysPasswordExpiration: '',
      company_settings: null,
      errorConfigPassword: false,
      loadingPassword: false,
      loadingPasswordConfig: false,
      listCompany_members: [],
      listCompany_inative: [],
      pending_invitations: [],

      alterPendingInvitation: false,
      userError: false,
      permission: false,
      owner: false,
      administrator: false,
      staff: false,
      loadingBtn: false,
      loadingBtnRole: false,
      loading: true,
      name: '',
      email: '',
      optionSelected: {
        name: 'viewer',
        id: 'viewer',
        description: 'youAreAllowedToViewTheReports',
      },

      optionRoleSelected: {
        name: 'viewer',
        id: 'viewer',
        description: 'youAreAllowedToViewTheReports',
      },

      userAlterRole: '',

      listOptions: [
        {
          name: 'owner',
          id: 'owner',
          description: 'allActionsAllowed',
        },
        {
          name: 'administrator',
          id: 'administrator',
          description: 'allowedToPayReward',
        },
        {
          name: 'analyst',
          id: 'analyst',
          description: 'youHavePermissionToViewAndEditReports',
        },
        {
          name: 'viewer',
          id: 'viewer',
          description: 'youAreAllowedToViewTheReports',
        },
      ],

      languageOptionSelected: { name: 'br', id: 'pt' },
      languageOptions: [
        { name: 'br', id: 'pt' },
        { name: 'en', id: 'en' },
        { name: 'es', id: 'es' },
      ],

      programSelected: [],
      listProgram: [],
      getUserType: '',
      getUserRole: '',
      twoFactoryAuthentication: false,
      programError: false,
      programSelectedUser: [],
    };
  },
  validations: {
    name: { required, regexOTN, minLength: minLength(6) },
    email: { required, email },
  },

  mounted() {
    this.getUserType = this.$store.getters['getUserType'];
    this.getUserRole = this.$store.getters['getUserRole'];
    let userType = this.$store.getters['getUserType'];
    this.getMyProfile(userType);
    this.changePrograms();
    this.permission = ['owner', 'administrator'].includes(
      this.$store.getters['getUser'].role
    )
      ? true
      : false;

    this.owner = ['owner'].includes(this.$store.getters['getUser'].role)
      ? true
      : false;

    this.administrator = ['administrator'].includes(
      this.$store.getters['getUser'].role
    );
    this.staff =
      this.$store.getters['getUser'].email.endsWith('@bughunt.com.br');

    if (
      this.$store.getters['getUser'].role == 'owner' &&
      !this.$store.getters['getUser'].email.endsWith('@bughunt.com.br')
    ) {
      this.listOptions = this.listOptions.filter(
        (item) => item.name != 'owner'
      );
    } else if (this.$store.getters['getUser'].role == 'administrator') {
      this.listOptions = this.listOptions.filter(
        (item) => !['owner', 'administrator'].includes(item.name)
      );
    }
    this.optionSelected = this.listOptions[0];
    this.optionRoleSelected = this.listOptions[0];

    if (this.$store.getters['getUserType'] == 'company') {
      this.company_settings = this.$store.getters['getUser'].company_settings;
      this.expirePassword =
        this.company_settings.expire_password == true
          ? this.company_settings.expire_password
          : false;
      this.numberOfDaysPasswordExpiration =
        this.company_settings.expire_password == true
          ? this.company_settings.days_to_expire
          : 0;

      this.changeMembers();
    }

  },
  watch: {
    userAlterRole() {
      this.updateList = this.userAlterRole?.programs;
    },
    numberOfDaysPasswordExpiration() {
      this.errorConfigPassword = false;
    },
  },
  computed: {
    programSelectedUserComputed() {
      return this.programSelectedUser;
    },
  },
  methods: {
    ...mapActions(['setUser', 'setAmountPrograms']),

    getPrograms(data) {
      this.programSelected = data.listPrograms;
      this.programSelectedUser = data.listPrograms;
    },
    featureActivationAction(type) {
      this.actionType = type;
    },

    handleTagRemoved(removedTag, removedIndex) {
      console.log(`Tag "${removedTag}" foi removida do índice ${removedIndex}`);
    },

    async updateConfigPassword(actionOpcional) {
      this.errorConfigPassword = false;
      this.loadingPasswordConfig = true;

      const convertToNumber = Number(this.numberOfDaysPasswordExpiration);
      if (isNaN(convertToNumber)) {
        this.loadingPasswordConfig = false;
        return (this.errorConfigPassword = true);
      }

      try {
        const payload = {
          active: actionOpcional != 'disable' && Number(this.numberOfDaysPasswordExpiration) > 0 ? this.expirePassword : !this.expirePassword,
          days: Number(this.numberOfDaysPasswordExpiration),
        };
        if(Number(this.numberOfDaysPasswordExpiration) <= 0 ){
          if(actionOpcional != 'disable'){
            Swal.fire({
            icon: "warning",
            title: this.$ml.get('swalTotalDays'),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          }   
          this.loadingPasswordConfig = false;
          return;
        }
        const { status } = await CompanyService.putPasswordConfig(payload);

        const requestedCuccessfully = 200;
        if (status === requestedCuccessfully) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("configSuccess"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });

          let userType = this.$store.getters["getUserType"];
          this.getMyProfile(userType);
        }
        this.loadingPasswordConfig = false;
      } catch (error) {
        if (error.response.data.statusCode === 403) {
          Swal.fire({
            icon: "info",
            html: `<h4 class="mb-1">${this.$ml.get(
              "userDoesNotHavPermissionToPerform",
            )}</h4> 
              <label> 
              </label>  
              `,
            showConfirmButton: false,
            timer: 30000,
          });
        }
        this.loadingPasswordConfig = false;
    }
  },

    async updateProgram(id, statusProgram) {
      try {
        const user_status = statusProgram === 'active' ? false : true;
        const payload = {
          programs: this.programSelectedUser.map((i) => i._id),
        };
        const { status } = await CompanyService.putProgramMembers(
          id,
          user_status,
          payload
        );
        if (status === 200) {
          Swal.fire({
            icon: 'success',
            title: this.$ml.get('swalSuccess'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    changePrograms() {
      const pageActive = 1;
      const pageSize = 999;
      ProgramService.getProgram("", pageActive, pageSize).then((response) => {
        this.listProgram = response.data.items;
      });
    },

    nameLang({ name }) {
      return `${this.$ml.get(name)}`;
    },

    showModalRole(item, pending) {
      this.programSelectedUser = item?.programs ?? [];
      let initial_role_selection = this.listOptions.findIndex(
        (i) => i.id === item.role
      );
      this.optionRoleSelected =
        this.listOptions[
          initial_role_selection != -1 ? initial_role_selection : 0
        ];

      this.alterPendingInvitation = pending;

      this.$bvModal.show('modal-alterRole');
      this.userAlterRole = item;
    },
    changeMembers() {
      this.loading = true;

      CompanyService.getMembers().then(
        (response) => {
          this.loading = false;
          this.listCompany_members = response.data.company_members;
          this.pending_invitations = response.data.pending_invitations;
          this.listCompany_inative = [];
          this.listCompany_members.forEach((element) => {
            if (element.status == 'inactive') {
              this.listCompany_inative.push(element);
            }
          });
        },
        () => {
          this.loading = false;
        }
      );
    },

    async saveUser() {
      var self = this;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.userError = true;
        return;
      }

      this.loadingBtn = true;
      this.userError = false;

      const recaptchaV3Token = await executeRecaptchaV3(RECAPTCHA_V3_ACTIONS.ADD_USER);

      CompanyService.postMembers({
        name: this.name.trim(),
        email: this.email.toLowerCase(),
        user_type: this.optionSelected.id,
        language: this.languageOptionSelected.id,
        programs: this.programSelected.map((program) => program._id),
        ...(recaptchaV3Token && { recaptchaV3Token }),
      }).then(
        (response) => {
          this.loadingBtn = false;
          if (response.data == 'limit_exceeded') {
            self.verifyPlan();
            return;
          }
          this.$refs.selectProgramComponent.listProgramSelected = [];
          this.changeMembers();
          this.name = '';
          this.email = '';
          this.programSelected = [];
          Swal.fire({
            icon: 'success',
            title: self.$ml.get('invitationSent'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          this.changeMembers();
        },
        (error) => {
          this.loadingBtn = false;
          if(error.response.data.message === 'Necessário domínio verificado'){
            return Swal.fire({
                icon: 'warning',
                title: self.$ml.get('requiredRegisterDomain'),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });   
          }
          if (error.response.data.message === 'company_member_limit_exceeded') {
            return Swal.fire({
            icon: 'warning',
            title: self.$ml.get('invitationLimitManagersReached'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          }
          if (
            error.response.data.message ==
            'E-mail para convite já possui cadatro'
          ) {
            return Swal.fire({
            icon: 'warning',
            title: self.$ml.get('emailAlreadyRegistered'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          }
          if (
            error.response.data.message ===
            'O email selecionado já possui um convite pendente!'
          ) {
            return  Swal.fire({
            icon: 'warning',
            title: self.$ml.get('pendingInviteAlert'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          }

          Swal.fire({
            icon: 'warning',
            title: self.$ml.get('unableToCompleteThisRequest'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          
        }
      );
    },

    removeUser(email) {
      var self = this;

      Swal.fire({
        heightAuto: false,
        text: self.$ml.get('areYouSureYouWantToDeleteThisUser'),
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#730ba9',
        customClass: {
          cancelButton: 'btn-outline-extra',
        },
        confirmButtonText: self.$ml.get('remove'),
        cancelButtonText: self.$ml.get('cancel'),
      }).then((result) => {
        if (result.value) {
          CompanyService.deleteMembers(email).then(
            () => {
              Swal.fire({
                icon: 'success',
                title: self.$ml.get('userRemoved'),
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
              });
              this.changeMembers();
            },
            (error) => {
            console.log(error);
            Swal.fire({
              icon: 'warning',
              title: self.$ml.get('unableToCompleteThisRequest'),
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
            });
              
            }
          );
        }
      });
    },
    
    removePendingUser(id) {
      var self = this;

      Swal.fire({
        heightAuto: false,
        text: self.$ml.get('areYouSureYouWantToDeleteThisUser'),
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#730ba9',
        customClass: {
          cancelButton: 'btn-outline-extra',
        },
        confirmButtonText: self.$ml.get('remove'),
        cancelButtonText: self.$ml.get('cancel'),
      }).then((result) => {
        if (result.value) {
          CompanyService.deletePendingMembers(id).then(
            () => {
              Swal.fire({
                icon: 'success',
                title: self.$ml.get('userRemoved'),
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
              });
              this.changeMembers();
            },
            (error) => {
              if (error.response.status == 403) {
                Swal.fire({
                  icon: 'info',
                  title: self.$ml.get('unableToCompleteThisRequest'),
                  showConfirmButton: false,
                  timer: 3000,
                });
              }
            }
          );
        }
      });
    },

    async alterStatusUser(id) {
      var self = this;

      CompanyService.putMembers(id).then(
        (response) => {
          if (response.data == 'limit_exceeded') {
            self.verifyPlan();
            return;
          }

          Swal.fire({
            icon: 'success',
            title:
              self.$ml.get('user') +
              (response.data.status == 'active'
                ? self.$ml.get('activated')
                : self.$ml.get('inactivated')),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          setTimeout(() => {
            this.changeMembers();
          }, 300);
        },
        (error) => {
          if(error.response.data.message === 'Domínio do usuário não verificado!'){
            return Swal.fire({
                icon: 'warning',
                title: self.$ml.get('requiredRegisterDomain'),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });   
          }
          if (error.response.status == 403) {

          console.log(error);

            Swal.fire({
            icon: 'warning',
            title: self.$ml.get('unableToCompleteThisRequest'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          
        }
    });
    },

    async alterRoleUser(user, role, id, status) {
      var self = this;
      this.loadingBtnRole = true;
      Swal.fire({
        text: self.$ml.get('AreYouSureYouWantToUpdateTheUserRole'),
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#730ba9',
        customClass: {
          cancelButton: 'btn-outline-extra',
        },
        confirmButtonText: self.$ml.get('save'),
        cancelButtonText: self.$ml.get('cancel'),
      }).then((result) => {
        if (result.value) {
          CompanyService.putMembersRole(
            user._id,
            role.id,
            this.alterPendingInvitation
          ).then(
            (response) => {
              console.log(
                '🚀 ~ file: user.vue:552 ~ alterRoleUser ~ response',
                response
              );
              self.loadingBtnRole = false;
              setTimeout(() => {
                self.$bvModal.hide('modal-alterRole');
                this.changeMembers();
              }, 300);
            },
            (error) => {
              console.dir(error);
              self.loadingBtnRole = false;
              self.$bvModal.hide('modal-alterRole');
              if (error.response.status == 403) {
                Swal.fire({
                  icon: 'info',
                  title: self.$ml.get('unableToCompleteThisRequest'),
                  showConfirmButton: false,
                  timer: 3000,
                });
              } else {
                Swal.fire({
                  icon: 'info',
                  title: self.$ml.get('unableToCompleteThisRequest'),
                  showConfirmButton: false,
                  timer: 3000,
                });
              }
            },
            this.updateProgram(id, status)
          );
        } else {
          this.loadingBtnRole = false;
        }
      });
    },

    async verifyPlan() {
      var self = this;
      Swal.fire({
        icon: 'info',
        html: `<h3 class="mb-2">${self.$ml.get('userLimitReached')}<h3> 
        <h5 class="mb-2">
          ${self.$ml.get(
            'toAddMoreUsersCheck'
          )} <a href="/account?plans">${self.$ml.get('here')}</a>  
        </h5>`,
        showConfirmButton: false,
        timer: 10000,
      });
    },

    getMyProfile(type) {
      var self = this;

      AccountService.getAccountMy().then((response) => {
        if (type == 'company') {
          self.setUser({
            account_avatar: response.data.account_avatar,
            account_createdAt: response.data.account_createdAt,
            companyName: response.data?.companyName,
            company_avatar: response.data?.company_avatar,
            company_settings: response.data?.settings,
            company_createdAt: response.data.company_createdAt,
            email: response.data.email,
            name: response.data.name,
            role: response.data?.role,
          });
          self.setAmountPrograms(response.data.amount_of_programs);
          self.twoFactoryAuthentication =
            response.data.settings.two_factor_auth_required;
          self.canRequestEmailCode =
            response?.data?.plan?.can_request_email_code;
          self.emailAuthentication =
            response?.data?.settings?.email_code_required;
          this.company_settings =
            this.$store.getters['getUser'].company_settings;
          this.expirePassword =
            this.company_settings.expire_password == true
              ? this.company_settings.expire_password
              : false;
          this.numberOfDaysPasswordExpiration =
            this.company_settings.expire_password == true
              ? this.company_settings.days_to_expire
              : 0;

          this.$store.dispatch("setUser", {
            two_factor_auth_login: response.data?.two_factor_auth_login,
            email_code_required: response.data?.email_code_required,
         });
        }
      });
    },
  },
};
</script>

<style scoped>
.msgn {
  color: #730ba9;
}
.remove {
  background-color: rgba(241, 65, 65, 0.03);
}
.container-tags {
  margin-top: 15px;
  width: 100%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}
.tag-item {
  position: relative;
  border: 1px solid #8a0ba9;
  border-radius: 5px;
  color: #8a0ba9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(204, 204, 204, 0);
  padding: 3px 20px 3px 4px;
}
.tag-title {
  margin: 0px;
  padding: 0px;
  font-weight: 500;
  font-size: 0.92rem;
}
.remove-tag {
  position: absolute;
  top: 0px;
  right: 5px;
  font-weight: bold;
  font-size: 0.78rem;
  color: #890ba9be;
  cursor: pointer;
}
.remove-tag:hover {
  color: #7a0c96;
}
.desc-two-factory {
  font-size: 1rem;
}
.desc-two-factory span {
  font-weight: 500;
}
</style>
